// extracted by mini-css-extract-plugin
module.exports = {"button":"ThreeDotsButton-module__button--2t79B"};